/* eslint-disable */
import Vue from "vue";
import store from '../../../../store/store.js';
import * as d3 from "d3";
import _ from 'lodash';
import { CrainD3Vis, CrainData } from "./CrainD3Vis.js";
import { createToolTip, ellipsis, getColorScale } from "./utilities";
import { EventBus } from '@/eventBus';

class DocUniverse extends CrainD3Vis {

    constructor(svg, cd, cdThemes) {
        super(svg, cd);
        this.crainDataThemes = cdThemes;

        this.temp = {
            fields: undefined,
            documents: undefined,
            themes: undefined
        };
        this.data = {
            fields: {},
            recentdocuments: {},
            themes: [],
            subsetfilt: {}
        };
        this.layout = {
            width: undefined,
            height: undefined,
            margin: undefined,
            minCircle: undefined,
            maxCircle: undefined,
            rectSize: undefined,
            xScale: undefined,
            yScale: undefined,
            fieldMax: undefined,
            colorScheme: undefined,
            contourColor: undefined,
            isolate: undefined,
            showRings: undefined,
            showRingsOverlap: undefined,
            showRingsNoMatch: undefined,
            showArrows: undefined,
            showDocs: undefined,
            showLabels: undefined,
            showContour: undefined,
            showFields: undefined,
            showFieldsNames: undefined,
            showThemes: undefined,
            unassignedColor: undefined,
        };
        this.config = {
            width: 1600,
            height: 1000,
            margin: 100,
            cutoff: 0.2,
            minConnections: 2,
            minCircle: 3,
            maxCircle: 20,
            curCircle: null,
            rectSize: 6,
            colorScheme: d3.schemeCategory10.concat(d3.schemeTableau10),
            contourColor: d3.interpolate("#fefefe", "#999999"),//d3.interpolateBuGn
            isolate: false,
            showRings: false,
            showRingsOverlap: true,
            showRingsNoMatch: false,
            showArrows: true,
            showDocs: true,
            showContour: true,
            showFields: true,
            showFieldsNames: true,
            showLabels: false,
            showThemes: true,
            unassignedColor: "#82a894",
            showLegends: true
        };
        this.responsive = false;
        this.force = false; // Whether force needs to be visualized
        this.simulation = undefined; // Where simulation (force is stored)
        // As it might take some time to show tooltip, it can be that mousepointer is already gone when
        // the tooltip is still waiting for the request. This checks whether the tooltip still needs to be shown.
        this.showTooltip = false;
        this.zoomShowDocs = false;
        this.hoverGroup = undefined;
        this.selectedGroups = new Set();
    }


    layoutCalculations() {

        if (this.svg.attr('width') && this.svg.attr('height')) {
            //this.layout.width = this.svg.attr('width');
            //this.layout.height = this.svg.attr('height');
            this.layout.width = document.getElementById('svgDiv').offsetWidth;
            this.layout.height = document.getElementById('svgDiv').offsetHeight;
        } else {
            this.layout.width = this.config.width;
            this.layout.height = this.config.height;


            this.svg.attr('width', this.layout.width);
            this.svg.attr('height', this.layout.height);
        }
        this.layout.margin = this.config.margin;
        this.layout.minCircle = this.config.minCircle;
        this.layout.maxCircle = this.config.maxCircle;
        this.layout.rectSize = this.config.rectSize;

        this.layout.colorScheme = this.config.colorScheme;
        this.layout.contourColor = this.config.contourColor;
        this.layout.unassignedColor = this.config.unassignedColor;

    }

    setConfig(config) {
        // If config is undefined, no changes to layout will occur, to copy changes from config to layout use config={}

        if (config !== undefined) {
            this.layout.showRings = "showRings" in config ? config.showRings : this.config.showRings;
            this.layout.showRingsOverlap = "showRingsOverlap" in config ? config.showRingsOverlap : this.config.showRingsOverlap;
            this.layout.showRingsNoMatch = "showRingsNoMatch" in config ? config.showRingsNoMatch : this.config.showRingsNoMatch;
            this.layout.showArrows = "showArrows" in config ? config.showArrows : this.config.showArrows;
            this.layout.showDocs = "showDocs" in config ? config.showDocs : this.config.showDocs;
            this.layout.showNoMatch = "showNoMatch" in config ? config.showNoMatch : this.config.showNoMatch;
            this.layout.showOverlap = "showOverlap" in config ? config.showOverlap : this.config.showOverlap;
            this.layout.showContour = "showContour" in config ? config.showContour : this.config.showContour;
            this.layout.showFields = "showFields" in config ? config.showFields : this.config.showFields;
            this.layout.showFieldsNames = "showFieldsNames" in config ? config.showFieldsNames : this.config.showFieldsNames;
            this.layout.showLabels = "showLabels" in config ? config.showLabels : this.config.showLabels;
            this.layout.showThemes = "showThemes" in config ? config.showThemes : this.config.showThemes;
            this.layout.isolate = "isolate" in config ? config.isolate : this.config.isolate;
            this.layout.minConnections = "minConnections" in config ? config.minConnections : this.config.minConnections;
            this.layout.cutoff = "cutoff" in config ? config.cutoff : this.config.cutoff;
            this.layout.currentTransform = d3.zoomIdentity;
        }
    }

    setScale() {
        let xext = d3.extent(this.temp.fields, d => d.coor[0]);
        let yext = d3.extent(this.temp.fields, d => d.coor[1]);

        let xr = xext[1] - xext[0];
        let yr = yext[1] - yext[0];

        let marRat = 0.05;
        let xmin = xext[0] - xr * marRat;
        let xmax = xext[1] + xr * marRat;
        let ymin = yext[0] - yr * marRat;
        let ymax = yext[1] + yr * marRat;

        this.layout.xScale = d3.scaleLinear().domain([xmin, xmax])
            .range([0 - this.layout.width / 2 + this.layout.margin, this.layout.width / 2 - this.layout.margin]);
        this.layout.yScale = d3.scaleLinear().domain([ymin, ymax])
            .range([0 - this.layout.height / 2 + this.layout.margin, this.layout.height / 2 - this.layout.margin]);

        // Needs to happen from the initially loaded fields, not from the fields from craindata: craindata objects
        // remove the layers(fields) that (due to the filters) have no size
        this.temp.fields.forEach(field => {
            let f = {...field };
            f.clicked = false;
            this.data.fields[field._id] = f;
        });
    }

    /**
     * Convert and fill data elements
     */
    prepDataInit(newData = true) {

    }

    prepDataFilter(newData = true) {
        if (newData) {

            // Reset external data
            let sizes = [];
            Object.values(this.data.fields).forEach(field => {
                field.data = { 'size': 0 };
                field.pos = undefined;
                field.radius = undefined;
            });

            // Add new Data to fields
            sizes = [];
            for (let c = 0; c < this.crainData.xLayers.length; c++) {
                let key = c + "_0_0_0"; // Alldata
                let _id = this.crainData.xLayers[c][0]._id;
                let f = this.crainData.rawData.data[0][key];
                let field = this.data.fields[_id];
                field.pos = c;
                field.data = f.filtdata ? f.filtdata : f.data;
                sizes.push(f.data.origsize);
            }
            this.layout.fieldMax = Math.max(...sizes);
            Object.values(this.data.fields).forEach(f => {
                f.radius = (((f.data.size / this.layout.fieldMax) ** 0.5) * this.layout.maxCircle) + this.layout.minCircle;
            });

            // Associate documents
            this.data.recentdocuments = {};
            this.data.olddocuments = {};
            this.crainData.rawData.documents.recentdocuments.forEach(doc => {
                doc.groups = 0; // Will contain group information if additional filters were used
                this.data.recentdocuments[doc._id] = doc;
            });

            this.crainData.rawData.documents.alldocuments.filter(d => !(d._id in this.data.recentdocuments))
              .forEach(doc => {
                doc.groups = 0; // Will contain group information if additional filters were used
                this.data.olddocuments[doc._id] = doc;
            });
            // Empty subsetfilters
            this.data.subsetfilt = {};

            //
            this.data.forceData = [];
            this.crainDataThemes.xLayers.forEach((theme, c) => {
                this.data.forceData.push({...theme[0], ...this.crainDataThemes.processedData[c] })
            });
        } else {
            // Just reset associated groups
            Object.values(this.data.recentdocuments).concat(Object.values(this.data.olddocuments)).forEach(d => d.groups = 0)
        }

        // Save documents and filter groups

        this.crainData.rawData.documents.ydocuments.forEach((filt, c) => {
            // Group with index 0: is All documents
            // Group with index 1: is Overlap
            if (c > 0) {
                filt.forEach(doc => {
                  if ((doc._id) in this.data.recentdocuments) {
                    this.data.recentdocuments[doc._id].groups = c
                  } else {
                    this.data.olddocuments[doc._id].groups = c
                  }
                });
            }
        });
    }

    prepArcs() {
        let rawData = this.crainData.rawData.data[0];
        let pie = d3.pie().sort(null);
        let ySize = this.crainData.yLayers.length; // Overlap with specific filters

        Object.values(this.data.fields).forEach(field => {
            let fdata = [];
            // Data: 0: Alldata - 1: overlap - 2--n other data points
            for (let d = 0; d < ySize; d++) {
                let key = field.pos + "_" + d + "_0_0";
                fdata.push(rawData[key] ? rawData[key].data.size : 0)
            }

            // Replace alldata with other values or 0
            if (this.layout.showRingsNoMatch) {
                fdata[0] = fdata[0] - fdata.slice(1).reduce((a, b) => a + b);
            } else {
                fdata[0] = 0;
            }

            let arcs = pie(fdata);
            // Adding necessary information to arcs, for further d3 interaction
            arcs.forEach(function(p) {
                p._id = field._id + '_' + p.index;
                p.radius = field.radius;
                p.group = p.index;
            });
            field.arcs = arcs;
        });

    }

    assignColors() {
        Object.values(this.data.recentdocuments).concat(Object.values(this.data.olddocuments)).forEach(doc => {
            if (doc.groups === 0) {
                doc.color = this.layout.unassignedColor;
            } else {
                //console.log(this.layout.colorScheme);
                doc.color = this.layout.colorScheme[doc.groups - 1];
            }
        });
    }

    async getHierarchyData() {
        this.temp.documents = store.state.document.documentsData;
        this.temp.fields = store.state.field.fields;
        this.colorDocuments = this.colorDocuments.bind(this);
    }

    hideTooltip() {
        this.showTooltip = false;
        d3.select('#hovertooltip').remove();
    }

    removeFieldSelect() {
        Object.values(this.data.fields).forEach(d => d.clicked = false);
        this.update();
    }

    createGLayers(resetZoom = false) {
        
        let g = this.svg.append("g").attr('id', 'gDocUniv');
        g.attr("transform", "translate(" + this.layout.width / 2 + "," + this.layout.height / 2 + ")");
        // Used to fetch zoom event
        g.append('rect').attr('id', 'zoomrect').style('opacity', '1')
            .attr('width', this.layout.width).attr('height', this.layout.height)
            .attr('transform', 'translate(' + -this.layout.width / 2 + ',' + -this.layout.height / 2 + ')')
            //.attr('fill', d => this.layout.contourColor(0))
            .attr('fill', '#ffffff')
            .on('mouseover', this.hideTooltip)
            //.on('click', this.removeFieldSelect.bind(this));
    
        g.append('g').attr('id', 'gDuHex').attr('class', 'gSvgLayer');
        g.append('g').attr('id', 'gDuLinks').attr('class', 'gSvgLayer');
        g.append('g').attr('id', 'gDuFields').attr('class', 'gSvgLayer');
        g.append('g').attr('id', 'gDuDocuments').attr('class', 'gSvgLayer');
        g.append('g').attr('id', 'gDuArcs').attr('class', 'gSvgLayer');
        g.append('g').attr('id', 'gDuThemes').attr('class', 'gSvgLayer');
        g.append('g').attr('id', 'gDuFieldLinks').attr('class', 'gSvgLayer');
        g.append('g').attr('id', 'gDuLegend').attr('class', 'gLegend')
            .append('text').text("Legend").attr('font-weight', 'bold')
            .attr('font-family','Montserrat, Century Gothic');
        g.append('g').attr('id', 'gDuInfo').attr('class', 'gInfo');

        // Zooming
        let zoomed = () => {
            
            let transform = d3.event.transform;
            
            let zoomDir = 'zoomin';
            let prevTransform = null;
            //console.log(transform.k, this.layout.currentTransform.k);
            if(transform.k > this.layout.currentTransform.k){ 
                zoomDir='zoomin';
                prevTransform = this.layout.currentTransform.k;
            }
            else{
                zoomDir='zoomout';
            }
            //console.log(zoomDir);
            this.layout.currentTransform = transform;
            if (this.simulation) this.simulation.stop();
            this.showTooltip = false;
            d3.select('#hovertooltip').remove();
            if (!(resetZoom)) d3.selectAll('#gDuDocuments > g').remove(); // Remove documents on zoom
            

            let zf = 4; // Zoomfactor controls zooming => if 0: zoomcorrection == transform.k (no zooming) // if inf: zoomcorrection = 1 (normal zoom)
            let delayedTransform = (zf + transform.k) / (zf + 1);
            let zf1 = 0.25;
            let delayedTransform1 = (zf1 + transform.k) / (zf1 + 1);
            let zf2 = 0.75;
            let delayedTransform2 = (zf2 + transform.k) / (zf2 + 1);
            this.zoomShowDocs = transform.k > 20; //2.5 

            // recover the new scale
            //var newX = d3.event.transform.rescaleX(this.layout.xScale);
            //var newY = d3.event.transform.rescaleY(this.layout.yScale);

            // update axes with these new boundaries
            //g.call(d3.axisBottom(newX))
            //g.call(d3.axisLeft(newY))

            let layers = g.selectAll('.gSvgLayer')
                .attr('transform', transform);

            // Calculate center
            let centerX = 0;
            let centerY = 0;
            let scale = transform.k;

            // Move cFields (fields) away from center as you zoom in
            layers.selectAll('g.cFields')
                .attr('transform', f => {
                    let origX = this.layout.xScale(this.force ? f.fx : f.coor[0]);
                    let origY = this.layout.yScale(this.force ? f.fy : f.coor[1]);
                    let newX = centerX + (origX - centerX) * scale;
                    let newY = centerY + (origY - centerY) * scale;
                    return 'translate(' + newX + ',' + newY + ')';
                });

            // Move cArts (documents) away from center as you zoom in
            layers.selectAll('g.cArts')
                .attr('transform', a => {
                    if (!a.coor) return 'translate(0,0)';
                    let origX = this.layout.xScale(a.coor[0]);
                    let origY = this.layout.yScale(a.coor[1]);
                    let newX = centerX + (origX - centerX) * scale;
                    let newY = centerY + (origY - centerY) * scale;
                    return 'translate(' + newX + ',' + newY + ')';
                });

            layers.selectAll('rect')
                .style('stroke-width', 1 / delayedTransform)
                .attr('width', this.layout.rectSize / delayedTransform) // Delayed zoom
                .attr('height', this.layout.rectSize / delayedTransform); // Delayed zoom

            layers.selectAll('.cArts > circle')
                .style('stroke-width', 1 / delayedTransform1)
                .attr('r', this.layout.minCircle / delayedTransform1);

            layers.selectAll('.cFields > circle')
                .style('stroke-width', 1 / delayedTransform1)
                .attr('r', function() {
                    if(transform.k === 1){
                        return d3.select(this).attr("rel");
                    }
                    else if(zoomDir === 'zoomin'){
                        //console.log(transform.k);
                        return d3.select(this).attr("rel") - (transform.k - 1);
                    }
                    else{
                        //console.log(transform.k);
                        if(transform.k < 1){
                            return d3.select(this).attr("rel");
                        }
                        else{
                            return d3.select(this).attr("rel") - (transform.k - 1);
                        }
                    }
                });
                
            layers.selectAll('.fieldArrow')
                //.style('stroke-width', 5 / delayedTransform1)
                .attr('transform', function() {
                    return 'scale(' + (d3.select(this).attr("rd") - (transform.k - 1))/64 + ')translate(-' + d3.select(this).attr("mid") + ',-' + d3.select(this).attr("mid") + ')rotate(' + d3.select(this).attr("ang") + ',' + d3.select(this).attr("mid") + ',' + d3.select(this).attr("mid") + ')';
                });
                //.attr('transform', 'scale(' + ((d3.select(this).attr('rd')/64) - (transform.k * 0.2)) + ')translate(-' + d3.select(this).attr('mid') + ',-' + d3.select(this).attr('mid') + ')rotate(' + d3.select(this).attr('ang') + ',' + d3.select(this).attr('mid') + ',' + d3.select(this).attr('mid') + ')');

            layers.selectAll('.cFields > text')
                // Keep text always just below the circle, regardless of zoom, with a small font scaling
                .attr("dy", d => parseFloat(d.radius) + 10)
                .attr("font-size", () => 10 * (1 + 0.002 * (this.layout.currentTransform.k - 1))) // Slightly increase font size with zoom
                .call(this.fieldsText.bind(this));

            layers.selectAll('text')
                // Make all text scale a little with zoom, but much less than circles
                .attr('font-size', 10 * (0.80 + 0.02 * transform.k));
                //.attr('stroke-width', 0.5 / delayedTransform);
            

        };

        var zoom = d3.zoom()
            .scaleExtent([0.5, 5])
            .extent([[-this.layout.width, -this.layout.height], [this.layout.width, this.layout.height]])
            .on("zoom", zoomed)
            .on("end", () => {
                let clickedFields = Object.values(this.data.fields).filter(field => field.clicked);
                if (clickedFields.length === 0) {
                    this.drawDocuments(g);
                }
            });

        if (resetZoom) {
            g.call(zoom.transform, d3.zoomIdentity);
            return
        }
        g.call(zoom);

        //g.call( d3.brush()                 // Add the brush feature using the d3.brush function
        //    .extent( [ [-this.layout.width,-this.layout.height], [this.layout.width,this.layout.height] ] ) // initialise the brush area: start at 0,0 and finishes at width,height: it means I select the whole graph area
            //.on("start brush", zoomed) // Each time the brush selection changes, trigger the 'updateChart' function
        //);

        return g;
    }

    colorDocuments(selection) {
        selection.style('fill', d => d.color)
            .style('fill-opacity', 0.5)
            .style('stroke-width', 1)
            .style('stroke', d => d.color)
    }

    fieldsText(selection) {
      selection.text(f => ellipsis(f.name, Math.ceil(this.layout.currentTransform.k * 25)))
      .attr('font-family','Montserrat, Century Gothic');
    }

    drawHex(g) {
        let layer = g.select('#gDuHex');

        let contour = d3.contourDensity()
            .x(d => this.layout.xScale(d.coor[0]) + this.layout.width / 2)
            .y(d => this.layout.yScale(d.coor[1]) + this.layout.height / 2)
            .size([this.layout.width, this.layout.height]);

        layer.selectAll("path.contour").remove();
        let contours = contour(Object.values(this.data.recentdocuments).filter(d => d.coor));

        let contourColor = d3.scaleSequential(this.layout.contourColor)
            .domain([0, d3.max(contours, d => d.value) * 1.5]);

        layer.selectAll("path.contour")
            .data(contours)
            .enter()
            .append("path")
            .attr('class', 'contour')
            .attr("d", d3.geoPath())
            .attr("fill", d => contourColor(d.value))
            .attr("stroke", "#69b3a2")
            .attr('stroke-width', 0)
            .attr("stroke-linejoin", "round")
            .attr("transform", "translate(" + (-this.layout.width / 2) + "," + (-this.layout.height / 2) + ")")
            .on('mouseover', this.hideTooltip);
            //.on('click', this.removeFieldSelect.bind(this));


        // Might be implemented later: sets second contour for the non-recent
        // let contours2 = contour(Object.values(this.crainData.rawData.documents.ydocuments[0])
        //   .filter(d => (!(d._id in this.data.recentdocuments)) &&  d.coor));

        // let contourColorOld = d3.scaleSequential(d3.interpolateBlues)
        //   .domain([0, d3.max(contours2, d => d.value)]);
        //
        // layer.selectAll("path.contourold")
        //   .data(contours2)
        //   .enter()
        //   .append("path")
        //   .attr('class', 'contourold')
        //   .attr("d", d3.geoPath())
        //   .attr("fill", d => contourColorOld(d.value))
        //   .attr("stroke", "#69b3a2")
        //   .attr('stroke-width', 0)
        //   .attr('opacity', 0.2)
        //   .attr("stroke-linejoin", "round")
        //   .attr("transform", "translate(" + (-this.layout.width / 2) +  "," + (-this.layout.height / 2) + ")")
        //   .on('mouseover', this.hideTooltip)

    }

    drawDocuments(g) {
        if (Object.keys(this.data.recentdocuments).length + Object.keys(this.data.olddocuments).length > 1000000) {
            let svgLayer = g.select('#gDuDocuments');
            let cArts = svgLayer.selectAll('g.cArts');
            cArts.remove();
        } else {
            let groups = new Set(this.selectedGroups);
            if (this.hoverGroup !== undefined) groups.add(this.hoverGroup);
            let layer = g.select('#gDuDocuments');
            if (this.layout.showDocs || this.zoomShowDocs || groups.size > 0 ) {
                let docs = Object.values(this.data.recentdocuments).concat(Object.values(this.data.olddocuments));
                if (groups.size === 0) {
                  docs = docs.filter(d => {
                    switch (d.groups) {
                      case 0:
                        return this.layout.showNoMatch;
                      case 1:
                        return this.layout.showOverlap;
                      default:
                        return true
                    }
                  });
                } else {
                  docs = docs.filter(d => groups.has(d.groups))
                }

                let cArts = layer.selectAll('g.cArts').data(docs, d => d._id);
                let newArts = cArts.enter()
                    .append('g')
                    .attr('class', 'cArts')
                    .attr('transform', a => a.coor ? 'translate(' + this.layout.xScale(a.coor[0]) + ',' + this.layout.yScale(a.coor[1]) + ')' : 'translate(0,0)');

                newArts.append('circle');
                newArts.merge(cArts)
                    .on('mouseover', art => {
                        let colorScale = d3.scaleLinear().domain([0, 1]).interpolate(d3.interpolateHcl).range(['rgb(230,230,230)', 'red']);

                        let a = d3.json(Vue.prototype.$globalSettings.api_endpoint + '/article?hu_id=test&doc=' + art._id +
                            '&aggregate=false&titledate=true', {
                                headers: {
                                    Authorization: localStorage.getItem('jwt') || '',
                                    "Requested-Data-Source": "data"
                                }
                            });

                        let b = d3.json(Vue.prototype.$globalSettings.api_endpoint + '/aggregateconnection/', {
                            method: "POST",
                            body: JSON.stringify({
                                hu_id: "test",
                                filt: art._id,
                                hierarchies: ["Fields"]
                            }),
                            headers: {
                                Authorization: localStorage.getItem('jwt') || '',
                                "Requested-Data-Source": "data"
                            }
                        });

                        let event = d3.event;
                        this.showTooltip = true;
                        Promise.all([a, b]).then(x => {
                            // Change field visualization
                            let colorScale = d3.scaleLinear().domain([0, 1]).interpolate(d3.interpolateHcl)
                                .range(['rgb(230,230,230)', 'red']);

                            let o = Object.entries(x[1]); //FieldIds, values
                            let fields = [];
                            if (o.length > 0) {
                                let sf = new Set(o.map(f => f[0])); // fieldIds
                                let total = o.map(f => f[1]).reduce((a, b) => a + b); // Sum totals
                                o.map(f => { f[1] = f[1] / total }); // Ratio
                                fields = o.map(f => [this.data.fields[f[0]].name, f[1]]);

                                d3.selectAll('g.cFields')
                                    .filter(f => sf.has(f['_id']))
                                    .select('circle')
                                    .style('fill', f => colorScale(x[1][f._id]));
                            }

                            // Join data and create tooltip
                            x[0].type = "Document";
                            x[0].fields = fields;
                            // Check if state to show tooltip is still valid, due to asynchronousity
                            if (this.showTooltip) {
                                createToolTip(x[0], event);
                            }
                        });

                    })
                    .on('mouseout', function() {
                        this.showTooltip = false;
                        d3.select('#hovertooltip').remove();
                        d3.selectAll('g.cFields')
                            .select('circle')
                            .style('fill', 'rgb(230,230,230)');

                    })
                    .on('click', function(d) {
                        EventBus.$emit('showDoc', d._id);
                    })
                    .select('circle')
                    .attr('r', d => d._id in this.data.recentdocuments ? this.layout.minCircle : this.layout.minCircle / 3)
                    .call(this.colorDocuments);

                cArts.exit().remove();
            } else {
              let cArts = layer.selectAll('g.cArts');
              cArts.remove();
            }
        }
    }

    drawFields(g, selectedFields = undefined) {

        let layer = g.select('#gDuFields');
        let svgArrow = "M46 26 L56 26 L32 0 L8 26 L18 26 L18 64 L46 64 Z";

        // Fielddata is put together from local hierarchydata, and from variable data retrieval
        let data = (selectedFields ? selectedFields : Object.values(this.data.fields));
        let cFields = layer.selectAll('g.cFields').data(data, f => f._id);

        cFields.exit().remove();
        let newFields = cFields.enter().append('g')
            .attr('class', 'cFields');

        newFields.merge(cFields).attr('transform', f => 'translate(' + this.layout.xScale(this.force ? f.fx : f.coor[0]) +
            ',' + this.layout.yScale(this.force ? f.fy : f.coor[1]) + ')');
        newFields.append('circle')
            .attr('stroke-width', '1')
            .on('mouseover', d => {
                this.showTooltip = true;
                //console.log(d);
                createToolTip(d);
                if (this.layout.showDocs) {
                    let url = Vue.prototype.$globalSettings.api_endpoint + '/docs/' + d._id;
                    d3.json(url, {
                        headers: {
                            Authorization: localStorage.getItem('jwt') || '',
                            "Requested-Data-Source": "data"
                        }
                    }).then(x => {
                        let sa = new Set(x);
                        d3.selectAll('g.cArts > circle')
                            .filter(x => sa.has(x._id))
                            .style('stroke', 'red');
                    })
                }
            })
            .on('mouseout', d => {
                this.showTooltip = false;
                d3.selectAll('g.cArts > circle').call(this.colorDocuments);
                d3.select('#hovertooltip').remove();
            })
            .on('click', d => {
                // Necessary if you want to show connection

                // if (d.clicked) {
                //     d.clicked = !d.clicked;
                //     // Reset coordinates to original position
                //     //d.fx = d.coor[0];
                //     //d.fy = d.coor[1];
                // } else {
                //     d.clicked = true;
                // }
                EventBus.$emit('showOptions', d);
                //this.update();
            });    
        newFields.merge(cFields).select('circle')
            .attr('r', f => f.radius ? f.radius : this.layout.minCircle)
            .attr('rel', f => f.radius ? f.radius : this.layout.minCircle)
            .attr('stroke', d => d.clicked ? 'red' : 'gray')
            .style('fill', 'rgb(255,255,255)')
            .style('opacity', d => (d.clicked || (!selectedFields)) ? 1 : 0.4)
            .attr('stroke-opacity', d => (d.clicked || (!selectedFields)) ? 1 : 0.4);

        // Draw Arrows
        //let scaleDown = 0.2;
        let mid = (64 / 2); // Translate depends on size of icon (64x64 => 64/2*0.2 - 64/2*0.2);
        let rotator = d3.scaleLinear().domain([3, -3]).range([0, 180]).clamp(true);
        let arrowColor = d3.scaleLinear()
            .domain([-2, -1, 0, 1, 2])
            .range(["#710193", "#2fffe7", "#333333", "#F07E2A", "#E15109"])//#4B8378(dark green),#138808(green)
            .clamp(true)
            .interpolate(d3.interpolateRgb);

        newFields.append('path')
            .attr('class', 'fieldArrow')
            .attr('d', svgArrow)
            .on("click", function(d) {
                EventBus.$emit('showOptions', d);
            });

        newFields.merge(cFields)
            .selectAll('path.fieldArrow')
            .attr('rd', d => d.radius ? d.radius : this.layout.minCircle/64)
            .attr('mid', mid)
            .attr('ang', d => d.data.recency !== undefined ? rotator(d.data.recency) : 0)
            .attr('transform', d => 'scale(' + (d.radius ? d.radius : this.layout.minCircle)/64 + ')translate(-' + mid + ',-' + mid + ')rotate(' + (d.data.recency !== undefined ? rotator(d.data.recency) : 0) + ',' + mid + ',' + mid + ')')
            .style('fill', d => arrowColor(d.data.recency))
            .style('opacity', d => d.data.recency !== undefined ? ((d.clicked || !selectedFields) ? 1 : 0.2) : 0)
            .attr('stroke', function(d) { return d.clicked ? 'red' : 'gray' });

        // Draw Arcs
        let arcs = newFields.merge(cFields).selectAll('g > path.fieldArcs')
            .data(field => {
                field.arcs.forEach(arc => arc.field_id = field._id);
                return field.arcs
            }, field => field._id);

        let newArcs = arcs.enter()
            .append('path')
            .attr('class', 'fieldArcs');


        arcs.merge(newArcs)
            .attr("d", function(arc) {
                return d3.arc().innerRadius(0.5 * arc.radius).outerRadius(arc.radius)(arc);
            })
            .on('mouseover', d => {
                let o = {};
                let lay = this.crainData.yLayers[d.index];
                o.name = lay.map(l => l ? l.name : "Other").join(' - ');
                o.size = d.value;
                o.type = "Arc";
                this.showTooltip = true;
                createToolTip(o);
            })
            .on('mouseout', d => {
                this.showTooltip = false;
                d3.select('#hovertooltip').remove();
            })
            .on('click', d => {
                let o = {};
                let lay = this.crainData.yLayers[d.index];
                o.name = lay[0].name;
                o.type = lay[0].type;
                o.url = lay[0].url;
                o._id = lay[0]._id;
                o.info = 'Indice';
                let f = { "_id": d.field_id };
                EventBus.$emit('showOptions', [o, f]);
            })
            // Group 0 => Other data, unassigned data
            .attr("fill", d => d.group ? this.layout.colorScheme[d.group - 1] : this.layout.unassignedColor);

        arcs.exit().remove();

        // Field names
        newFields.append('text')
            .style('fill', '#111')
            .attr('text-anchor', 'middle')
            .attr('font-size', 10);

        newFields.merge(cFields).select('text')
            .attr("dy", d => parseFloat(d.radius) + 10)
            // .attr('transform', function(d) {
            //     let dy = parseFloat(d.radius) + 10;
            //     return 'translate(0,' + dy + ')'
            // });


        newFields.merge(cFields).selectAll('text')
            .style('display', this.layout.showFieldsNames ? 'inline' : 'none')
            .call(this.fieldsText.bind(this));
    }

    /**
     * Draws Themes, and also other elements when using force) by adding themes -> if that is the case show them.
     * **/
    drawThemes(force = false, selectedThemes = undefined) {

        let setSelThemes = selectedThemes ? new Set(selectedThemes.map(x => x._id)) : new Set();
        let layer = d3.select('#gDuThemes');
        // Only show selectedThemes (via force) or those with a coordinate (when they are mapped)
        let cThemes = layer.selectAll('g.cThemes').data(selectedThemes || this.data.forceData.filter(x => x.coor), t => t._id);
        let { scale, interpolator, dataLabel } = getColorScale("recency_linear");

        cThemes.exit().remove();
        let newThemes = cThemes.enter().append('g')
            .attr('class', 'cThemes')
            .on('mouseover', function(t) {
                //d3.select(this).select('text').style('display', 'block');
                this.showTooltip = true;
                createToolTip(t);
            })
            .on('mouseout', function() {
                //d3.select(this).select('text').style('display', 'none');
                this.showTooltip = false;
                d3.select('#hovertooltip').remove();
            })
            .on("click", function(t) {
                EventBus.$emit('showOptions', t);
            });

        cThemes.merge(newThemes)
            .attr('transform', t => 'translate(' + this.layout.xScale(force ? t.x || t.coor[0] : t.coor[0]) + ',' +
                this.layout.yScale(force ? t.y || t.coor[1] : t.coor[1]) + ')')
            .attr('display', t => t.type === "Theme" ? (this.layout.showThemes || setSelThemes.has(t._id) ? 'inline' : 'none') : 'inline')
            .style('fill', t => t.data ? interpolator(scale(t.data.recency)) : "rgb(255,255,255)");

        newThemes.append('rect')
            .attr('width', this.layout.rectSize)
            .attr('height', this.layout.rectSize)
            .attr('transform', 'translate(' + (-this.layout.rectSize / 2) + ',' + (-this.layout.rectSize / 2) + ')')
            .style('stroke-width', 1)
            .style('stroke', 'gray');

        newThemes.append('text')
            .text(d => d.name)
            .attr('fill', '#800000')
            .attr('text-anchor', 'middle')
            .attr('font-family','Montserrat, Century Gothic')
            .attr('font-size', 10)
            .attr('transform', d => {
                let dy = this.layout.rectSize + 10;
                return 'translate(0,' + dy + ')'
            });

        if (this.layout.showLabels) {
            // Show All
            newThemes.merge(cThemes).selectAll('text').attr('display', 'inline')
        } else {
            // Remove all
            newThemes.merge(cThemes).selectAll('text').attr('display', 'none')
        }

    }

    /**
     * Generates Force graph of fields with selected themes (or other filters, like applicants, ...)
     *
     * @param g (g#main)
     * @param clickedFields
     * @returns {*}
     */
    createForce(g, clickedFields) {

        // Remove fields that are deselected
        let idFields = new Set(clickedFields.map(x => x._id));
        Object.keys(this.data.subsetfilt).forEach(_id => {
            if (!idFields.has(_id)) {
                delete this.data.subsetfilt[_id];
            }
        });

        // Prepare query on newly clicked fields;
        let newClicks = clickedFields.map(x => x._id).filter(_id => (!(_id in this.data.subsetfilt)));
        let queries = [];
        let q = JSON.parse(this.crainDataThemes.request);
        newClicks.forEach(nc => {
            q.ylayers = null;
            q.zlayers = [null];
            q.subset_filters = [nc];
            q.postprocessing = [];
            queries.push(new CrainData(JSON.stringify(q)).load())
        });

        // Fetch data of clickedfields, draw and calculate force
        if (queries.length > 0) {
            Promise.all(queries).then(cds => {
                cds.forEach(cd => {
                    let _id = cd.subsetLayers[0]._id;
                    this.data.subsetfilt[_id] = cd;
                });
                this.calculateDrawForce(g, clickedFields)
            });

        } else {
            this.calculateDrawForce(g, clickedFields)
        }
    }

    calculateDrawForce(g, clickedFields) {

        // Put fields in new (circular) position
        if (this.layout.isolate) {
            let num_clicked = clickedFields.length;
            let radius = (Math.min(this.layout.width, this.layout.height) - 30) / 2;
            let angles = d3.range(0, 360, 360 / num_clicked);
            let newcoors = angles.map(angle => [(Math.cos(angle * Math.PI / 180) * radius), (Math.sin(angle * Math.PI / 180) * radius)]);
            clickedFields.map((field, c) => {
                field.fx = this.layout.xScale.invert(newcoors[c][0]);
                field.fy = this.layout.yScale.invert(newcoors[c][1]);
            })
        }

        // Select fields
        let field_nodes = [];
        Object.values(this.data.fields).forEach((field, c) => {
            let t = field;
            delete field.index;
            if (this.layout.isolate) {
                if (t.clicked) field_nodes.push(t)
            } else {
                t.fx = field.coor[0];
                t.fy = field.coor[1];
                field_nodes.push(t)
            }
        });

        // Reset data
        this.data.forceData = [];
        // Check each subsetfilter and fetch data
        Object.keys(this.data.subsetfilt).sort().forEach((fieldId, fc) => {
            let cd = this.data.subsetfilt[fieldId];
            cd.xLayers.forEach((el, c) => {
                let lay;
                // Reset each layer the first run
                if (fc === 0) {
                    lay = el[0];
                    lay.linked = 0;
                    lay.links = [];
                    let key = c + "_0_0_0";
                    lay.data = cd.rawData.data[0][key].data;
                    this.data.forceData.push(lay);
                } else {
                    lay = this.data.forceData[c]
                }
                let key = c + "_0_0_0";
                let filtdata = cd.rawData.data[0][key].filtdata;
                let val = filtdata.linked;
                let match = filtdata.size;
                if (val >= this.layout.cutoff) {
                    lay.linked += 1;
                    let fieldId = cd.subsetLayers[0]._id;
                    lay.links.push([this.data.fields[fieldId], lay, val, match])
                }
            })
        });

        // Select Links
        let sel_layers = [];
        let links = [];
        this.data.forceData.filter(x => x.linked >= this.layout.minConnections).forEach(layer => {
            sel_layers.push(layer);
            links = links.concat(layer.links)
        });

        // Start simulation before adding links, such that .index information is present
        let nodes = field_nodes.concat(sel_layers);
        let simulation = this.simulation || d3.forceSimulation().nodes(nodes);
        simulation.nodes(nodes);

        if (links.length > 0) {
            let maxMatch = d3.max(links.map(x => x[3]));
            links = links.map(function(x) {
                return { 'source': x[0].index, 'target': x[1].index, 'strength': x[2], 'match': x[3] / maxMatch }
            })
        }

        simulation.force('charge', d3.forceManyBody().strength(-0.5))
            //.force('collision', d3.forceCollide().radius(function(){return 1}))
            // Distance is divided by strength => if link.strentgh is weak, like 0.01 the distance will be multiplied by 2 (math.log10)
            .force('link', d3.forceLink().links(links).distance(function() { return 2 })
                .strength(function(link) {
                    return link.strength
                }))
            .force('tick', () => {
                let layer = d3.select('#gDuLinks');
                let cLinks = layer.selectAll('g.cLinks').data(links);
                cLinks.exit().remove();
                let newLinks = cLinks.enter().append('g')
                    .attr('class', 'cLinks')
                    .append('line');

                cLinks.merge(newLinks).select('line').attr('x1', l => this.layout.xScale(l.source.fx))
                    .attr('y1', l => this.layout.yScale(l.source.fy))
                    .attr('x2', l => this.layout.xScale(l.target.x))
                    .attr('y2', l => this.layout.yScale(l.target.y))
                    .attr('stroke', 'black')
                    .attr('stroke-width', l => (l.match * 10) + 0.5)
                    .attr('stroke-opacity', 0.05);

                d3.selectAll('.gDuLinks');
                this.drawThemes(true, sel_layers);
            });

        if (this.simulation) {
            simulation.alpha(1).restart()
        } else {
            this.simulation = simulation;
        }

        this.drawFields(g, field_nodes);

        return simulation
    }

    drawLegends(g) {
      // Draw legend
      let legend = this.svg.select("#gDuLegend");
      legend.attr('transform', d => 'translate(' + ((this.layout.width / 2) - 100) + ',' + ((-this.layout.height / 2) + 20) + ')')

      // Draw Info
      let info = this.svg.select("#gDuInfo");
      info.attr('transform', d => 'translate(' + ((-this.layout.width / 2) + 20) + ',' + ((-this.layout.height / 2) + 20) + ')');
      let period = this.crainData.rawData.meta.startyear + " - " + this.crainData.rawData.meta.recentyear + " - " + this.crainData.rawData.meta.stopyear;
      let filter = this.crainData.rawData.layers[4][0];
      let filterText = "";
      if (filter) {
        if (filter.name === "%%TemPFILTER%%") {
          // Filter coming from eg Wikipedia
          filterText = filter.rawquery[0].name
        } else {
          filterText = filter.name
        }
        filterText = filterText? filterText.charAt(0).toUpperCase() + filterText.slice(1):"Filter";
      }

      let infoData = [period, filterText];
      info.selectAll('text.cInfos').remove();
      let cInfos = info.selectAll('text').data(infoData);
      cInfos.enter().append("text")
        .attr("class", "cInfos")
        .text(d => d)
        .attr('font-family','Montserrat, Century Gothic')
        .attr('font-weight', 'bold')
        .attr('font-size', (d,c) => c ? 14: 16)
        .attr('transform', (d,c) => 'translate(0,' + (c * 20) + ')');

      legend.selectAll('g.cLegendItems').remove();
      let cLegendItems = legend.selectAll('g.cLegendItems').data(this.crainData.yLayers,
        d => d[0] ? d[0]._id : "No match");


      let newLegends = cLegendItems.enter().append("g")
        .attr('class', 'cLegendItems cursor-pointer')
        .attr('transform', (d, c) => 'translate(0,' + ((c + 1) * 18) + ")")
        .on('mouseover', (d,c) => { createToolTip(d[0]); this.hoverGroup = c; this.drawDocuments(g)})
        .on('mouseout', () => {this.hoverGroup = undefined; this.drawDocuments(g)})
        .on('click', (d, c, a) => {

          if (this.selectedGroups.has(c)) {
            this.selectedGroups.delete(c);
          } else {
            this.selectedGroups.add(c);
          }
          d3.selectAll(a).attr('opacity', (d, c) => this.selectedGroups.size === 0 || this.selectedGroups.has(c) ? 1 : 0.5);
          d3.selectAll(a).attr('font-weight', (d, c) => this.selectedGroups.size === 0 || ! this.selectedGroups.has(c) ? 'normal' : 'bold');

          this.hoverGroup = undefined;  // If there is a click event ignore hover;
          this.drawDocuments(g);
        });

      newLegends.append('circle')
        .attr('r', 4.5)
        .attr('transform', d => "translate(-16,-4.5)")
        .attr('fill', (d, c) => {
          if (!d[0]) {
            return this.layout.unassignedColor
          } else {
            return this.layout.colorScheme[c - 1]
          }
        });
      newLegends.append('text')
        .text(d => {
            if(d[0]){
                if(d[0].name.length > 10){
                    return d[0].name.slice(0, 10)+'...';
                }
                else{
                    return d[0].name;
                }
            }
            else{
                return "No match";
            }
        })
        .attr('font-family','Montserrat, Century Gothic');

      if (this.layout.showThemes) {

        legend.selectAll('g.cLegendItems').remove();
        let cLegendItems = legend.selectAll('g.cLegendItems').data([
            { _id: 1, name: 'Recency High', color: 'rgb(240, 126, 42)' },
            { _id: 2, name: 'Recency Low', color: 'rgb(144, 144, 144)' },
            { _id: 3, name: '(For Themes)', color: 'rgb(255, 255, 255)' }
          ],
          d => d._id);

        let newLegends = cLegendItems.enter().append("g")
          .attr('class', 'cLegendItems')
          .attr('transform', (d, c) => 'translate(0,' + ((c + 1) * 18) + ")");

        newLegends.append('circle')
          .attr('r', 4.5)
          .attr('transform', d => "translate(-16,-4.5)")
          .attr('fill', (d) => d.color);

        newLegends.append('text')
          .text(d => d.name.length>10? d.name.slice(0, 10)+'...':d.name)
          .attr('font-family','Montserrat, Century Gothic');
      }
    }

    async update(reset = false, newData = false, resetZoom = false, config = undefined) {
        this.responsive = false;
        if (this.simulation) this.simulation.stop();
        this.setConfig(config);
        if (reset || this.data === undefined) {
            this.svg.select('g#gDocUniv').remove();
            await this.getHierarchyData();
            this.prepDataInit(); // Only once
            this.layoutCalculations();
            this.setScale();
        }

        if (reset || newData) {
            this.prepDataFilter(true);
            this.assignColors();
        }

        this.prepArcs();

        let g = this.svg.select('g#gDocUniv');
        if (g.empty()) {
            g = this.createGLayers();
        }

        let clickedFields = Object.values(this.data.fields).filter(field => field.clicked);
        if (clickedFields.length > 0) {
            this.force = true;
            this.createForce(g, clickedFields);
        } else {
            // Hex
            this.drawHex(g);

            // Documents
            if(store.state.layout.docsDataState){
                this.drawDocuments(g);
            }

            // Fields
            this.drawFields(g);

            // Legends
            if(store.state.layout.docsDataState){
                this.drawLegends(g);
            }

            // Themes
            if(store.state.layout.docsDataState){
                this.drawThemes();
            }
        }

        // Only show layers that are requested - due to speed reasons for documents this will be regulated on a document level
        d3.select('#gDuHex').selectAll('path.contour').attr('display', this.layout.showContour ? 'inline' : 'none');
        d3.select('#gDuFields').selectAll('circle').attr('display', this.layout.showFields ? 'inline' : 'none');
        d3.select('#gDuDocuments').selectAll('.cArts').attr('display', this.layout.showDocs && clickedFields.length === 0 ? 'inline' : 'none'); // Do not show documents when fields are selected/clicked
        d3.select('#gDuFields').selectAll('path.fieldArcs').attr('display', this.layout.showRings ? 'inline' : 'none');
        d3.select('#gDuFields').selectAll('path.fieldArrow').attr('display', this.layout.showArrows ? 'inline' : 'none');
        setTimeout(() => {
            store.dispatch('loadAnimEnd');
        }, 1000);
    }
}

export { DocUniverse }
